export class Subscription {


  TenantId: number;
  HotelId: string;
  OrganizationCode: string;
  UserName: string;  
  EntityCode: string;
  subscriptionId: string;
  Module: string;
  BookingDate: any;
  StartDate: any;
  EffectiveStartDate: any;
  subscriptionType: string;
  Status: string;
  timeStamp: any;
  RenewalAmount: number;
  FullsubscriptionStartDate: any;
  ImplementationStatus: string;
  ImpCompletionDate: any;
  Trainer: number;
  TerminationDate: any;
  ReasonForTermination: string;
  TerminationNotes: string;
  Adjustment: boolean;
  PayrollProcessorEmail: string;
	PayrollImportNotificationEmail:string
  PayPeriodFrequency: string;
  PayPeriodStartDate: any;
  StartPayDate: any;
  OvertimeRules: string;
  MaxWeeklyHours: string;
  MaxDailyHours: string;
  PayrollExportType:string;
  TimeClockCount: string;
  TotalEmployees: string;
  PayrollProcessingDate: any;
  DataStartDate: any;
  AutoImport: boolean;
  Payroll: boolean;
  //IsPwdRequiredForTCbool: boolean;
  //IsFacialRecogEnable: boolean;
  IsPwdRequiredForTC: boolean;
  IsFacialRecogEnable: boolean;
  IsTipEnable: boolean;
  IsSmileID: boolean;
  PassFailThreshold: string;
  SubId: string;
  CC1NAME: string;
  CC1TITLE: string;
  CC1EMAIL: string;
  CC1PHONE: string;
  CC2NAME: string;
  CC2TITLE: string;
  CC2EMAIL: string;
  CC2PHONE: string;
  HC1NAME: string;
  HC1TITLE: string;
  HC1EMAIL: string;
  HC1PHONE: string;
  HC2NAME: string;
  HC2TITLE: string;
  HC2EMAIL: string;
  HC2PHONE: string;
  FlagStatus: number;
  SubDetails: any = [];
  CreatedBy: any;
  subscriptionServices?: any[];
 // AutoImportCurrentDate: any;
}



export class TimeClockDeviceDetails {
  uniqueNo: any;
  MachinId: string;
  DefaultLanguage: string ='English-(en-us)';
  Notes: string;
  SaveButtonCaption: string = 'Save & Close';
}



// WEBPACK FOOTER //
// ./src/app/Classes/SubscriptionClass.ts